<template>
    <div class="flex flex-1 flex-col items-center justify-center gap-3">
        <div class="flex items-center justify-center">
            <AxProgressSpinner />
        </div>
        <p v-if="!$slots.default && loadingText" class="flex items-center justify-center text-center">
            {{ $t(loadingText) }}
        </p>
        <p v-else class="flex items-center justify-center text-center">
            <slot />
        </p>
    </div>
</template>

<script setup lang="ts">
import { AxProgressSpinner } from '@axxone-system/hades';

defineOptions({
    customOptions: {
        name: 'AxModalLoading',
    },
});

defineProps({
    loadingText: {
        type: String,
        default: 'common.loading_data',
    },
});
</script>

